import { Link } from 'react-router-dom'
import { Col, Container, Row } from 'react-bootstrap'
import { currentYear } from '@/context/constants'
import logofooter from '@/assets/images/logofooter.png'

const EduFooter = () => {
  return (
    <footer className="edunav-footer pt-5 bg-light">
      <Container>
        <Row className="g-4">
          {/* Logo and Description */}
          <Col xs={12} md={4} lg={3} className="text-center text-md-start">
            <Link to="/">
              {/* <img className="light-mode-item mb-3" width={180} height={50} src={logofooter} alt="logo" /> */}
              <img className="item mb-3" width={150} height={10} src={logofooter} alt="logo" />
            </Link>
            <p className="small fs-6 px-3 px-md-0">
              EduNav connects students, educators, and employers to bridge skills gaps and create future-ready talent.
            </p>
          </Col>

          {/* Company & Quick Links */}
          <Col xs={12} md={8} lg={6}>
            <Row className="text-center text-sm-start ">
              <Col xs={6} sm={6} md={6}>
                <h6 className="mb-3 fw-semibold fs-5">Company</h6>
                <ul className="nav flex-column">
                  <li className="nav-item mb-2">
                    <Link className="nav-link p-0 fs-6" to="/who-we-are">
                      Who We Are
                    </Link>
                  </li>
                  <li className="nav-item mb-2">
                    <Link className="nav-link p-0 fs-6" to="/contact">
                      Contact us
                    </Link>
                  </li>
                  <li className="nav-item mb-2">
                    <Link className="nav-link p-0 fs-6" to="/courses">
                      Courses
                    </Link>
                  </li>
                </ul>
              </Col>

              <Col xs={6} sm={6} md={6} >
                <h6 className="mb-3 fw-semibold fs-5">Quick Links</h6>
                <ul className="nav flex-column">
                  <li className="nav-item mb-2">
                    <Link className="nav-link p-0 fs-6" to="/ground-reality">
                      Ground Reality
                    </Link>
                  </li>
                  <li className="nav-item mb-2">
                    <Link className="nav-link p-0 fs-6" to="/purpose">
                      Purpose
                    </Link>
                  </li>
                  <li className="nav-item mb-2">
                    <Link className="nav-link p-0 fs-6" to="/what-we-do">
                      What We Do
                    </Link>
                  </li>
                  <li className="nav-item mb-2">
                    <Link className="nav-link p-0 fs-6" to="/experiences">
                      Experiences
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>

          {/* Contact Info */}
          <Col xs={12} lg={3} className="text-center text-md-start lg-0">
            <h6 className="mb-3 fw-semibold fs-5">Contact</h6>
            <p className="mb-1 fs-6">
              General:{' '}
              <a href="mailto:contact@edunav.sg" className="fw-light">
                contact@edunav.sg
              </a>
            </p>
            <p className="mb-1 fs-6">
              Admin/Finance:{' '}
              <a href="mailto:adfin@edunav.sg" className="fw-light">
                adfin@edunav.sg
              </a>
            </p>
            <p className="mt-2 fs-6">
              22 Malacca Street #07-04
              <br />
              RB Capital Building
              <br />
              Singapore 048980
            </p>
          </Col>
        </Row>

        <hr className="mt-4" />

        {/* Footer Bottom */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start py-3">
          <div className="fs-6 mb-2 mb-md-0">&copy; {currentYear} EduNav Pte. Ltd.</div>
         <div>
  <a
    className="me-3 fs-6"
    href="/terms-and-conditions"
    target="_blank"
    rel="noopener noreferrer"
  >
    Terms of use
  </a>
  <a
    className="fs-6"
    href="/privacy-policy"
    target="_blank"
    rel="noopener noreferrer"
  >
    Privacy policy
  </a>
</div>

        </div>
      </Container>
    </footer>
  )
}

export default EduFooter
